/**
 * Constantes pour le header de bienvenue
 */
export const WELCOME_MESSAGES = {
  morning: [
    'Bonjour',
    'Bonne matinée',
    'Excellente journée',
    'Bon début de journée'
  ],
  afternoon: [
    'Bon après-midi',
    'Bonne journée',
    'Excellente après-midi'
  ],
  evening: [
    'Bonsoir',
    'Bonne soirée',
    'Excellente soirée'
  ],
  night: [
    'Bonne nuit',
    'Bonne soirée',
    'À bientôt'
  ],
  weekend: [
    'Bon week-end',
    'Profitez bien',
    'Bonne journée'
  ]
} as const

export const FALLBACK_GREETING = 'Bonjour'

export const DEFAULT_USER_NAME = 'Utilisateur'

export const WELCOME_SUBTITLE = 'Votre solution de gestion intelligente'

